import axios from "axios";
import router from "@/router";

const auth = {
  namespaced: true,
  state: {
    token: "",
    isAuthenticated: false,
  },

  mutations: {
    SET_USER_INFO(state, value) {
      state.token = value;
      state.isAuthenticated = true;
    },
  },

  actions: {
    authenticateUser({ commit }, payload) {
      console.log(payload);
      commit("SET_IS_LOADING", true, { root: true });
      axios
        .post("/auth/signin", payload)
        .then((res) => {
          commit("SET_USER_INFO", res.data.data.token);
          router.push("/");
        })
        .catch((err) => {
          if (err.response.data.message) {
            commit("SHOW_SNACKBAR", { text: `${err.response.data.message}`, color: "error" }, { root: true });
          } else {
            commit(
              "SHOW_SNACKBAR",
              {
                text: "Something went wrong! Please check your internet connection",
                color: "error",
              },
              { root: true }
            );
          }
        })
        .finally(() => commit("SET_IS_LOADING", false, { root: true }));
    },

    LOGOUT() {
      window.localStorage.removeItem("vuex");
      router.push("/login");
    },
  },
};

export default auth;
